<p [innerHTML]="'decisions.animator.mark.description.1'|translate" [i18nKey]="[{target: 'innerHTML', key: 'decisions.animator.mark.description.1'}]"></p>
<br/>
<div class="grid-x grid-margin-x align-middle">
    <p class="cell shrink" [innerHTML]="'decisions.animator.mark.description.2'|translate" [i18nKey]="[{target: 'innerHTML', key: 'decisions.animator.mark.description.2'}]"></p>
    <button class="cell shrink button _small" [routerLink]="'/parameters/quality/assignments-weights'"
            style="margin-bottom:12px"[i18nKey]="'decisions.animator.mark.description.link'"></button>
</div>
